import React from 'react';

const BlocksComponent = (props) => {
    const color1 = props.colors ? props.colors[0] : '#06628d';
    const color2 = props.colors ? props.colors[1] : '#f91a10';

    const size = props.size ? props.size : '300px';

    return(
        <svg
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            style={{
            margin: "auto",
            background: "none",
            display: "block",
            shapeRendering: "auto",
            }}
            width={ size }
            height={ size }
            viewBox="0 0 100 100"
            preserveAspectRatio="xMidYMid"
        >
            <rect x={19} y={19} width={20} height={20} fill={ color1 }>
            <animate
                attributeName="fill"
                values={ `${color2};${color1};${color1}` }
                keyTimes="0;0.125;1"
                dur="1s"
                repeatCount="indefinite"
                begin="0s"
                calcMode="discrete"
            />
            </rect>
            <rect x={40} y={19} width={20} height={20} fill={ color1 }>
            <animate
                attributeName="fill"
                values={ `${color2};${color1};${color1}` }
                keyTimes="0;0.125;1"
                dur="1s"
                repeatCount="indefinite"
                begin="0.125s"
                calcMode="discrete"
            />
            </rect>
            <rect x={61} y={19} width={20} height={20} fill={ color1 }>
            <animate
                attributeName="fill"
                values={ `${color2};${color1};${color1}` }
                keyTimes="0;0.125;1"
                dur="1s"
                repeatCount="indefinite"
                begin="0.25s"
                calcMode="discrete"
            />
            </rect>
            <rect x={19} y={40} width={20} height={20} fill={ color1 }>
            <animate
                attributeName="fill"
                values={ `${color2};${color1};${color1}` }
                keyTimes="0;0.125;1"
                dur="1s"
                repeatCount="indefinite"
                begin="0.875s"
                calcMode="discrete"
            />
            </rect>
            <rect x={61} y={40} width={20} height={20} fill={ color1 }>
            <animate
                attributeName="fill"
                values={ `${color2};${color1};${color1}` }
                keyTimes="0;0.125;1"
                dur="1s"
                repeatCount="indefinite"
                begin="0.375s"
                calcMode="discrete"
            />
            </rect>
            <rect x={19} y={61} width={20} height={20} fill={ color1 }>
            <animate
                attributeName="fill"
                values={ `${color2};${color1};${color1}` }
                keyTimes="0;0.125;1"
                dur="1s"
                repeatCount="indefinite"
                begin="0.75s"
                calcMode="discrete"
            />
            </rect>
            <rect x={40} y={61} width={20} height={20} fill={ color1 }>
            <animate
                attributeName="fill"
                values={ `${color2};${color1};${color1}` }
                keyTimes="0;0.125;1"
                dur="1s"
                repeatCount="indefinite"
                begin="0.625s"
                calcMode="discrete"
            />
            </rect>
            <rect x={61} y={61} width={20} height={20} fill={ color1 }>
            <animate
                attributeName="fill"
                values={ `${color2};${color1};${color1}` }
                keyTimes="0;0.125;1"
                dur="1s"
                repeatCount="indefinite"
                begin="0.5s"
                calcMode="discrete"
            />
            </rect>
        </svg>
    );
};

export { BlocksComponent };